<div class="add__professional--workspace w-[750px] min-h-[600px] h-[600px] custom-dialog-scrollbar">
  <div class="add__professional--workspace--close">
    <button mat-icon-button class="lex justify-end" (click)="closeDialog()">
      <span class="material-icons relative text-[#B1ACB0] font-semibold text-[30px] leading-9">close </span>
    </button>
  </div>

  <div>
    <div class="workspace__stepper--container">
      <div class="workspace__stepper--container--item" [ngStyle]="{ background: entityNameSection ? '#25508E' : '#7E9BD4' }"></div>
      <div class="workspace__stepper--container--item-2" [ngStyle]="{ background: membersSection ? '#25508E' : '#F3F6FA' }"></div>
    </div>

    @if(entityNameSection){
    <div class="app__centered-item flex-col h-[84%]">
      <div class="workspace__stepper--manage--setup">
        <div class="add__workspace--name">
          <form [formGroup]="entityForm">
            <div class="flex flex-col">
              <div class="app__form--attribute--title w-full text-center text-2xl leading-9">{{ headerText }}</div>
              <div class="w-full flex flex-col gap-2 mt-5">
                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Entity Name </mat-label>
                  <input
                    class="pl-1"
                    matInput
                    placeholder="Name"
                    formControlName="entityName"
                    (focus)="selectAllContent($event)"
                    (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
                  />
                </mat-form-field>

                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Entity Type </mat-label>
                  <mat-select #templateSelect class="transaction__select--form--field" placeholder="Type" formControlName="entityType">
                    @for (item of allEntityTemplates; track item) {
                    <mat-option
                      [value]="item.id"
                      [ngClass]="{ 'placeholder-option': item.id === placeholderEntityId }"
                      [ngStyle]="{ 'background-color': item.id === placeholderEntityId ? '#F3F6FA' : 'white', 'color': item.id === placeholderEntityId ? '#25508E' : 'black' }"
                    >
                      <span class="flex items-center justify-between w-full">
                        <span [ngStyle]="{ 'color': item.id === placeholderEntityId ? '#25508E' : 'black', 'font-weight': item.id === placeholderEntityId ? 'bold' : 'normal' }">{{ item.type }}</span>
                        @if (item.id === placeholderEntityId && entityForm.get('entityType').value !== item.id) {
                        <span class="flex items-center gap-1">
                          <mat-icon
                            class="placeholder-info-icon ml-1"
                            [matTooltip]="placeholderTooltip"
                            matTooltipClass="placeholder-tooltip"
                            matTooltipPosition="above"
                            style="color: #25508e !important;"
                          >
                            info_outline
                          </mat-icon>
                        </span>
                        }
                      </span>
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                @if (isPlaceholderSelected) {
                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Select Vault </mat-label>
                  <mat-select class="transaction__select--form--field" placeholder="Select Vault" formControlName="placeholderVault">
                    @if (placeholderVaultOptions?.length) {
                    @for (vault of placeholderVaultOptions; track vault?.id) {
                    <mat-option [value]="vault?.id">
                      {{ vault?.name }}
                    </mat-option>
                    }
                    } @else {
                    <mat-option [value]="''" disabled>No vaults available</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                }

                @if(currentUser.user_type == 'Professional'){
                <mat-form-field class="login-signup-form-desing w-full" appearance="fill">
                  <mat-label class="automtic-form-desing-lable"> Vault Owner </mat-label>
                  <mat-select
                    class="transaction__select--form--field"
                    panelClass="app__inline--mat--select--dropdown"
                    formControlName="vaultOwner"
                    [disableOptionCentering]="true"
                    (selectionChange)="onSelectChange($event)"
                  >
                    <div
                      class="app__discovery--header--search--field w-[94%] h-[38px] border-[1.2px] border-[#B1ACB066] font-open-sans not-italic m-3 mt-5"
                    >
                      <div class="app__centered-item w-full h-full px-5">
                        <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="14px" height="14px" /></span>
                        <input
                          class="h-full w-full ml-2 border-none outline-none text-[12px]"
                          type="text"
                          [formControl]="searchStringState"
                          placeholder="Search"
                          autocomplete="off"
                          (keydown.space)="$event.stopPropagation()"
                        />
                        @if(searchStringState.value){
                        <span matSuffix (click)="onClearSearchInput()">
                          <mat-icon class="text-[#898F9E] text-xl hover:cursor-pointer">close</mat-icon>
                        </span>
                        }
                      </div>
                    </div>
                    <div
                      class="max-h-[170px] min-h-[60px] overflow-y-auto mb-2"
                      *ngIf="(allWorkspaceMembers | filterWorkspace : searchStringState.value).length; else showEmptyState"
                    >
                      <mat-option
                        class="mr-1"
                        *ngFor="let member of allWorkspaceMembers | filterWorkspace : searchStringState.value; let i = index"
                        [value]="member.user_id"
                      >
                        <span> {{ member.name }} </span>
                      </mat-option>
                    </div>
                    <ng-template #showEmptyState>
                      <div class="h-[50px]" *ngIf="(allWorkspaceMembers | filterWorkspace : searchStringState.value).length == 0">
                        <span class="px-4 mt-4 text-gray-400"> Owner not found </span>
                      </div>
                    </ng-template>
                  </mat-select>
                </mat-form-field>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    } @if(membersSection){
    <div class="app__centered-item flex-col h-[80%]">
      <div class="workspace__stepper--manage--setup">
        <ng-container>
          <div class="add__workspace--member--container py-8">
            <div class="w-full flex flex-col">
              <div class="app__form--attribute--title w-full text-center">
                <div class="text-2xl leading-9 max-[480px]:text-sm max-[480px]:mb-0">{{ title }}</div>
              </div>
              <div class="w-full mt-2 mb-0">
                <div class="app__centered-item w-full">
                  <div class="w-full">
                    <manage-users
                      [data]="allNonProfessionalExistingUsers"
                      [userType]="'family'"
                      [isInputFullWidth]="true"
                      [placeHolder]="searchTextPlaceHolder"
                      [selectedUsers]="selectedMembers"
                      (openInviteDialog)="openInviteDialog()"
                      (selectConnectedUser)="selectConnectedUser($event)"
                    ></manage-users>
                  </div>
                </div>
              </div>
              <div class="w-full overflow-hidden" *ngIf="selectedMembers?.length">
                <div class="w-full text-sm font-sans font-bold">
                  Members <span class="text-k-blue">({{ selectedMembers.length }})</span>
                </div>
                <div class="w-full flex flex-col justify-between mt-3 max-[480px]:py-0 max-[480px]:px-[15px]">
                  <div class="w-full max-h-[250px] overflow-y-auto" [class]="selectedMembers.length > 3 ? 'pr-[6px]' : ''">
                    @for (user of selectedMembers; track user; let index = $index) {
                    <div
                      class="app__between--justified--content workspace__mobile---member--view workspace__member--infos--add"
                      [class]="index != 0 ? 'mt-4' : ''"
                    >
                      <div class="flex items-center max-[480px]:flex-col">
                        @if (user?.memberUser?.first_name || user?.memberUser?.user_first_name || user?.memberUser?.user_nick_name ||
                        user?.memberUser?.name) {
                        <div class="flex items-center max-[480px]:items-start">
                          @if (user?.memberUser?.isGroup) {
                          <div>
                            <img class="w-[46px] h-[46px]" src="assets/images/round-group-name.svg " />
                          </div>
                          } @if (!user?.memberUser?.isGroup) {
                          <ngx-avatars
                            [size]="50"
                            src="{{ user?.memberUser?.user_profile_image_url }}"
                            name="{{
                              user?.memberUser?.name ??
                                user?.memberUser?.user_nick_name ??
                                user?.memberUser?.nick_name ??
                                user?.memberUser?.user_first_name + ' ' + user?.memberUser?.user_last_name ??
                                user?.memberUser?.first_name + ' ' + user?.memberUser?.last_name
                            }}"
                            [round]="true"
                            initialsSize="2"
                          ></ngx-avatars>
                          }
                          <div class="flex flex-col gap-[2px]">
                            <span class="workspace__member--infos--name">{{
                              user.memberUser?.name ??
                                user.memberUser?.user_nick_name ??
                                user.memberUser?.nick_name ??
                                user.memberUser?.user_first_name + ' ' + user.memberUser?.user_last_name ??
                                user.memberUser?.first_name + ' ' + user.memberUser?.last_name
                                | titlecase
                                | truncateStrPipe : 24
                            }}</span>
                          </div>
                        </div>
                        }
                      </div>

                      @if(user?.is_creator){
                      <div class="mr-4"><span class="workspace__member--tag">Creator</span></div>
                      }@else{
                      <div class="app__centered-item text-center mr-2">
                        <span class="hover:cursor-pointer" (click)="deleteMember(user)">
                          <img src="assets/images/delete-alert.svg" class="w-8 h-8" />
                        </span>
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    }
  </div>

  <div class="add__workspace--bottom--section" [ngClass]="{ 'justify-between': membersSection, 'justify-end': !membersSection }">
    @if(membersSection){
    <div class="worspace__setup--new--backbtn" (click)="backItem()">
      <button class="worspace__setup--btn worspace__setup--back--btn" type="button" *ngIf="screenWidth > 480">
        <i class="material-icons back-arrow">arrow_back</i> Back
      </button>
      <div class="worspace__setup--btn worspace__setup--back--btn" *ngIf="screenWidth <= 480">
        <i class="material-icons back-arrow">arrow_back</i>
      </div>
    </div>
    }

    <div
      class="justify-end"
      *ngIf="screenWidth > 480"
      (click)="!isUserDisabledToSkip() && nextItem(membersSection ? true : isPlaceholderSelected)"
    >
      <button class="worspace__setup--btn bg-[#25508e] text-[#ffffff]" type="button" [class.disable-button-continue]="isUserDisabledToSkip()">
        <span *ngIf="membersSection || isPlaceholderSelected; else shownext">Save</span>
        <ng-template #shownext>
          <span class="app__centered-item">Continue</span>
        </ng-template>
      </button>
    </div>
  </div>

  <div class="w-full absolute bottom-0 right-0 left-0" *ngIf="screenWidth <= 480">
    <div class="setup__next--btn w-full" (click)="nextItem(membersSection ? true : isPlaceholderSelected)">
      <button
        type="button"
        class="worspace__setup--next--btn w-[90%] left-[5%]"
        [class.disable-button-continue]="isUserDisabledToSkip()"
        style="right: unset"
      >
        <span *ngIf="membersSection || isPlaceholderSelected; else shownext">Save</span>
        <ng-template #shownext>
          <span class="app__centered-item">Next</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>

@if (formData?.length) {
<div class="hidden">
  <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
</div>
}
